import React, { useState, useRef, useEffect } from "react";
import { motion } from 'framer-motion';
import { Link } from "react-router-dom";
import { FaYoutube as FaYoutubeRaw } from 'react-icons/fa';
const FaYoutube = FaYoutubeRaw as React.ComponentType<{ className?: string }>;

export const YouTubeVideo = ({ videoId, autoplay = false, controls = true, mute = false }: { videoId: string, autoplay?: boolean, controls?: boolean, mute?: boolean }) => {
  const src = `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay ? 1 : 0}&controls=${controls ? 1 : 0}&mute=${mute ? 1 : 0}`;

  return (
    <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
      <iframe
        title="Youtube"
        src={src}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="w-full h-full"
      ></iframe>
    </div>
  );
};

const MediaGallery: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(false);
  const playerRef = useRef<HTMLIFrameElement>(null);

  console.log(isPlaying,setIsPlaying ,isMuted, setIsMuted)

  const videoIds = [
    "CAzhVsumNJI",
    "qlNmkEXhP1Y",
  ];

  const galleryImages = [
    { 
      src: "/images/image1.jpg", 
      alt: "Medical consultation with child", 
      caption: "Pediatric Growth Consultation" 
    },
    { 
      src: "/images/image2.jpg", 
      alt: "Doctor examining child", 
      caption: "Comprehensive Child Health Assessment" 
    },
    { 
      src: "/images/image3.jpg", 
      alt: "Doctor with family", 
      caption: "Family-Centered Medical Care" 
    },
    { 
      src: "/images/image4.jpg", 
      alt: "Child development checkup", 
      caption: "Developmental Milestone Evaluation" 
    },
    { 
      src: "/images/image5.jpg", 
      alt: "Doctor educating parents", 
      caption: "Parent Education Session" 
    },
    { 
      src: "/images/image6.jpg", 
      alt: "Child receiving treatment", 
      caption: "Specialized Pediatric Treatment" 
    },
  ];

  useEffect(() => {
    if (playerRef.current) {
      const player = playerRef.current;
      player.contentWindow?.postMessage(JSON.stringify({
        event: 'command',
        func: isPlaying ? 'playVideo' : 'pauseVideo'
      }), '*');
      player.contentWindow?.postMessage(JSON.stringify({
        event: 'command',
        func: isMuted ? 'mute' : 'unMute'
      }), '*');
    }
  }, [isPlaying, isMuted]);

  return (
    <>
      {/* <Helmet>
        <title>Educational Videos on Child Growth & Health | Dr. Swati Kanodia's Video Library</title>
        <meta name="description" content="Watch easy-to-understand videos about child growth, diabetes in kids, hormone problems, and teenage health. Dr. Swati Kanodia explains medical topics in simple terms for parents." />

        
        <meta property="og:title" content="Watch Child Health Videos - Dr. Swati Kanodia's Medical Guidance" />
        <meta property="og:description" content="Free educational videos explaining children's growth issues, diabetes, and hormone problems. Expert medical advice in simple language for parents." />
        <meta property="og:type" content="website" />

        
        <meta property="og:video:type" content="text/html" />
        <meta property="og:video:width" content="1280" />
        <meta property="og:video:height" content="720" />

      
        <meta name="keywords" content="child health videos, kids growth doctor videos, pediatric diabetes education, hormone problems in children videos, medical education for parents, child development videos, Dr Swati Kanodia youtube, kids health education" />

       
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Dr. Swati Kanodia" />

      
        <meta name="content-type" content="Educational Videos" />
        <meta name="content-category" content="Medical Education" />
        <meta name="target-audience" content="Parents, Caregivers" />

      
        <meta name="topic" content="Child Growth Videos" />
        <meta name="topic" content="Kids Health Education" />
        <meta name="topic" content="Medical Guidance for Parents" />
        <meta name="topic" content="Child Development Resources" /> 
      </Helmet>  
      */}

      <main className="flex-grow">

           <motion.section 
            id="imageGallery"
            className="w-full max-w-7xl mx-auto px-4 py-8 sm:py-12"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-pt-serif-regular mb-6 sm:mb-8 text-center text-brown">Dr. Hirak in News</h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {galleryImages.map((image, index) => (
                <motion.div
                  key={index}
                  className="overflow-hidden rounded-lg shadow-lg"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 * index }}
                >
                  <div className="relative group">
                    <img 
                      src={image.src} 
                      alt={image.alt} 
                      className="w-full h-64 object-cover transition-transform duration-500 ease-in-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                      <p className="text-white p-4 font-pt-serif-regular text-lg">{image.caption}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
              </div>
              </motion.section>


           

          <motion.section
            id="ytvideos"
            className="w-full max-w-7xl mx-auto px-4 py-8 sm:py-12"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-pt-serif-regular mb-6 sm:mb-8 text-center text-brown">Featured Videos</h1>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
              <div className="lg:col-span-2 space-y-4 sm:space-y-6">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <YouTubeVideo videoId={videoIds[0]} />
                </motion.div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                  >
                    <YouTubeVideo videoId={videoIds[1]} />
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    <YouTubeVideo videoId={videoIds[2]} />
                  </motion.div>
                </div>
              </div>
              <motion.div
                className="hidden lg:block"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <YouTubeVideo videoId={videoIds[3]} />
              </motion.div>
            </div>

            <div className="mt-8 sm:mt-10 flex justify-center">
              <Link
                to=''
                className="bg-red-600 text-white inline-flex items-center space-x-2 font-pt-serif-regular px-4 sm:px-6 py-2 sm:py-3 rounded-lg text-base sm:text-lg transition duration-300 ease-in-out hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 shadow-md hover:shadow-lg"
              >
                <span className="hidden sm:inline">Explore all Videos on YouTube</span>
                <span className="sm:hidden">YouTube Channel</span>
                <FaYoutube className="text-white w-5 h-5 sm:w-6 sm:h-6" />
              </Link>
            </div>
          </motion.section>
       
      </main>
    </>
  )
}

export default MediaGallery;
